import { Component, EventEmitter, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ListCartInputData } from '../../dave-list-card.component';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { FilterOption } from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { isArray } from 'chart.js/helpers';
import { FilterCardComponent } from '../../../dave-utils-module/app-filter-module/filter-card/filter-card.component';

export interface ListCardDialogComponentDialogData<T, F = any> {
    Data?: ListCartInputData<T>;
    Data$?: Observable<ListCartInputData<T>>;
    DisplayedCollums: Array<keyof T>;
    Clickable: boolean;
    GetRouterLinkFunction?: (args: T) => any[] | null | undefined;
    TableHeaderCollumsMap?: {}; //Map<keyof T, string> //{ [key: keyof T]: string};
    HasSuffixButton?: boolean;
    Headline: string;
    EmptyText?: string;
    Search?: boolean;
    footer?: TemplateRef<any>;
    CustomCellTemplates?: {[key: string]: TemplateRef<any>}
    headerSuffixTemplate?: TemplateRef<any>;
    Filter?: {
        FilterSettings: FilterOption[];
        InitialFilterValues?: F;
    }
}
@Component({
    selector: 'app-list-card-dialog',
    templateUrl: './list-card-dialog.component.html',
    styleUrls: ['./list-card-dialog.component.scss'],
})
export class ListCardDialogComponent<T, F = any> implements OnInit, OnDestroy {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        panelClass: [...appMatDialogDefaultConfig.panelClass, 'custom-dialog-class-without-padding'],
        minWidth: '20rem',
        width: '40vw',
        maxWidth: '100vw',
        closeOnNavigation: true,
    };

    @ViewChild('filterCard') filterCard: FilterCardComponent;

    public EntryClicked$ = new EventEmitter<{ entry: T; index: number }>();
    private routerSubscription: Subscription;
    public SearchForm = new FormControl<string>('');
    public SearchVisible = false;

    public filterValues$: BehaviorSubject<F> = new BehaviorSubject<F>(
        this.DialogData.Filter?.InitialFilterValues || {} as F,
    );

    public filterAmount$ = this.filterValues$.pipe(
        map((val: F) => {
            let filterAmount = 0;
            for (const [_, value] of Object.entries(val)) {
                if (isArray(value) && value?.length) {
                    filterAmount++;
                }
            }
            return filterAmount;
        }),
    );

    constructor(
        @Inject(MAT_DIALOG_DATA) public DialogData: ListCardDialogComponentDialogData<T>,
        private router: Router,
        private dialogRef: MatDialogRef<ListCardDialogComponent<T>>,
    ) {}

    ngOnInit(): void {
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: RouterEvent) => event instanceof NavigationStart),
                filter(() => !!this.dialogRef),
            )
            .subscribe(() => {
                this.dialogRef.close();
            });
    }

    ngOnDestroy() {
        this.routerSubscription?.unsubscribe();
        this.filterValues$.complete();
    }

    openFilterCard() {
        if (this.filterCard) {
            this.filterCard.Open();
        }
    }
}
